import { DataTable, DataTableCell } from "shared/types/__generated__/graphql"

import { SortOrder } from "./SortOrder"

export const DataTableTypename = "DataTable" as const

export interface ExtendedDataTableRow<T = DataTableCell[]> {
  key: string
  rowData: T
}
export interface ExtendedDataTable<T = DataTableCell[]> {
  header: DataTable["header"]
  body: ExtendedDataTableRow<T>[]
}

export interface TableSorting {
  key: string
  sortOrder: SortOrder | null
}
